import { render, staticRenderFns } from "./schoolAdd.vue?vue&type=template&id=0b0a0894&scoped=true&"
import script from "./schoolAdd.vue?vue&type=script&lang=js&"
export * from "./schoolAdd.vue?vue&type=script&lang=js&"
import style0 from "./schoolAdd.vue?vue&type=style&index=0&id=0b0a0894&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0a0894",
  null
  
)

export default component.exports